import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthFacade, AuthStrategies } from '@mds/ngx-auth';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  private readonly router = inject(Router);
  private readonly authFacade = inject(AuthFacade);

  canRedirect(status: number): boolean {
    return this.getRedirectAction(status) !== null;
  }

  performRedirect(status: number): void {
    this.getRedirectAction(status)?.();
  }

  private getRedirectAction(status: number): (() => void) | null {
    switch (status) {
      case 401:
        return () => this.authFacade.authenticate(AuthStrategies.Tenancy);

      case 402:
      case 403:
      case 404:
        return () => void this.router.navigate(['error', status]);

      default:
        return null;
    }
  }
}
